import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Code = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M13.0513 5.68378L9.05132 17.6838L10.9487 18.3162L14.9487 6.31623L13.0513 5.68378Z" fill="currentColor" />
    <path
      d="M17.2071 7.2929L21.9142 12L17.2071 16.7071L15.7929 15.2929L19.0858 12L15.7929 8.70711L17.2071 7.2929Z"
      fill="currentColor"
    />
    <path
      d="M6.79289 16.7071L2.08578 12L6.79289 7.2929L8.20711 8.70711L4.91421 12L8.20711 15.2929L6.79289 16.7071Z"
      fill="currentColor"
    />
  </Icon>
));

export default Code;
